import { useUserData } from './useUserData';

export const useCanViewArchive = () => {
  const { isAdmin, isProvidersAdmin, isProviderAdmin } = useUserData();
  return isAdmin || isProvidersAdmin || isProviderAdmin;
};
